import PostLoginRepository from "@adapters/features/PostLogin/Repository/PostLoginRepository";
import { qouteStream } from "@di";
export default (http, accountDetails) => {
    return {
        postLogin: new PostLoginRepository(http, accountDetails),
        quoteStream: qouteStream,
    };
};
